var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils as dataUtils } from '@easydata/core';
import { WidgetGroup } from '@easyquery/core';
import { HtmlContentWidget } from './html_content_widget';
/**
 * The widget responsed for rendering html grid.
 */
var EqHtmlGrid = /** @class */ (function (_super) {
    __extends(EqHtmlGrid, _super);
    /**
    * The default constructor.
    * @param slot The html element.
    */
    function EqHtmlGrid(slot) {
        var _this = _super.call(this, slot) || this;
        _this.options = {
            maxButtonCount: 10,
            useBootstrap: false
        };
        return _this;
    }
    EqHtmlGrid.prototype.getWidgetType = function () {
        return 'eqHtmlGrid';
    };
    /**
     * Initialize widget.
     * @param context The context.
     * @param options The options.
     */
    EqHtmlGrid.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.setOptions(options);
    };
    EqHtmlGrid.prototype.setOptions = function (options) {
        dataUtils.assignDeep(this.options, options);
    };
    /**
     * Refresh widget implementation
     */
    EqHtmlGrid.prototype.refreshCore = function () {
        _super.prototype.refreshCore.call(this);
        this.renderPageNavigator();
    };
    EqHtmlGrid.prototype.destroyCore = function () {
        this.slot.innerHTML = '';
    };
    /**
     * Renders page navigator.
     */
    EqHtmlGrid.prototype.renderPageNavigator = function () {
        var _this = this;
        var pageNavigatorPlaceholder = document.getElementById("PageNavigator");
        if (!pageNavigatorPlaceholder) {
            return;
        }
        var pageCount = parseInt(pageNavigatorPlaceholder.getAttribute('data-pagecount'));
        var pageIndex = parseInt(pageNavigatorPlaceholder.getAttribute('data-pageindex'));
        if (pageCount > 1) {
            var buttonClick = function (ev) {
                var element = ev.target;
                if (element.hasAttribute('data-page')) {
                    var pageNum = parseInt(element.getAttribute('data-page'));
                    _this.context.fetchDataChunk({
                        chunk: {
                            page: pageNum
                        },
                        success: function () {
                            _this.context.refreshWidgets(WidgetGroup.Result);
                        }
                    });
                }
            };
            var maxButtonCount = this.options.maxButtonCount || 10;
            var zeroBasedIndex = pageIndex - 1;
            var firstPageIndex = zeroBasedIndex - (zeroBasedIndex % maxButtonCount) + 1;
            var lastPageIndex = firstPageIndex + maxButtonCount - 1;
            if (lastPageIndex > pageCount) {
                lastPageIndex = pageCount;
            }
            var ul = document.createElement('ul');
            if (this.options.useBootstrap) {
                ul.className = "pagination";
            }
            else {
                ul.className = "eqv-pagination";
            }
            if (this.options.pageItemCssClass) {
                ul.className += " " + (this.options.pageItemCssClass);
            }
            var li = document.createElement('li');
            if (this.options.useBootstrap) {
                li.className = "page-item";
            }
            var a = document.createElement('span');
            a.setAttribute("aria-hidden", 'true');
            if (this.options.useBootstrap) {
                a.className = "page-link";
            }
            if (firstPageIndex == 1) {
                li.className += " disabled";
            }
            else {
                if (this.options.useBootstrap) {
                    a = document.createElement('a');
                    a.setAttribute('href', 'javascript:void(0)');
                    a.setAttribute("data-page", "" + (firstPageIndex - 1));
                    a.className = "page-link";
                }
                else {
                    var newA = document.createElement('a');
                    newA.setAttribute('href', 'javascript:void(0)');
                    newA.setAttribute("data-page", "" + (firstPageIndex - 1));
                    a = newA;
                }
                a.addEventListener("click", buttonClick);
            }
            a.innerHTML = "&laquo;";
            li.appendChild(a);
            ul.appendChild(li);
            for (var i = firstPageIndex; i <= lastPageIndex; i++) {
                li = document.createElement('li');
                if (this.options.useBootstrap) {
                    li.className = "page-item";
                }
                if (i == pageIndex)
                    li.className += " active";
                a = document.createElement('a');
                a.setAttribute('href', 'javascript:void(0)');
                a.innerHTML = i.toString();
                a.setAttribute('data-page', i.toString());
                a.className = "page-link";
                a.addEventListener("click", buttonClick);
                li.appendChild(a);
                ul.appendChild(li);
            }
            li = document.createElement('li');
            if (this.options.useBootstrap) {
                li.className = "page-item";
            }
            a = document.createElement("span");
            a.setAttribute('aria-hidden', 'true');
            if (this.options.useBootstrap) {
                a.className = "page-link";
            }
            if (lastPageIndex == pageCount) {
                li.className += "disabled";
            }
            else {
                if (this.options.useBootstrap) {
                    a = document.createElement('a');
                    a.setAttribute('href', 'javascript:void(0)');
                    a.setAttribute("data-page", "" + (lastPageIndex + 1));
                    a.className += " page-link";
                }
                else {
                    var newA = document.createElement('a');
                    newA.setAttribute('href', 'javascript:void(0)');
                    newA.setAttribute("data-page", "" + (lastPageIndex + 1));
                    a = newA;
                }
                a.addEventListener("click", buttonClick);
            }
            a.innerHTML = "&raquo;";
            li.appendChild(a);
            ul.appendChild(li);
            pageNavigatorPlaceholder.appendChild(ul);
        }
    };
    return EqHtmlGrid;
}(HtmlContentWidget));
export { EqHtmlGrid };
//# sourceMappingURL=eq_result_html_grid.js.map